<template>
  <draggable
    v-model="draggableGroups"
    handle=".handle"
    v-bind="dragOptions"
    @sort="didMove"
    @start="drag = true"
    @end="drag = false"
    easing="cubic-bezier(1, 0, 0, 1)"
  >
    <transition-group type="transition" :move-class="drag ? 'transform transition-all duration-0' : 'transform transition-all duration-300'">
      <slot v-for="group in draggableGroups" :group="group" :dragging="drag"></slot>
    </transition-group>
  </draggable>
</template>

<script>
import { tz }           from '@/tz'

import draggable from 'vuedraggable'
import gql       from 'graphql-tag'
import _nth      from 'lodash-es/nth'
import _get      from 'lodash-es/get'
import _sortBy   from 'lodash-es/sortBy'

export default {
  components: {
    draggable
  },

  props: ['groups'],

  data () {
    return {
      draggableGroups: this.groups,
      drag: false
    }
  },

  computed: {
    maxIndex () {
      return this.groups.length - 1
    },

    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      }
    }
  },

  watch: {
    groups: function () {
      this.draggableGroups = _sortBy(this.groups, 'order')
    }
  },

  methods: {
    didMove ({newIndex, oldIndex}) {
      const movedItem = _nth(this.draggableGroups, newIndex)
      const movedItemId = _get(movedItem, 'id')
      var newNumerator = undefined
      var newDenominator = undefined

      if (newIndex == 0) {
        const right = _nth(this.draggableGroups, newIndex + 1)
        newNumerator = _get(right, 'orderNumerator')
        newDenominator = _get(right, 'orderDenominator') + 1
      } else if (newIndex == this.maxIndex) {
        const left = _nth(this.draggableGroups, newIndex - 1)
        newNumerator = _get(left, 'orderNumerator') + 1
        newDenominator = _get(left, 'orderDenominator')
      } else {
        const left = _nth(this.draggableGroups, newIndex - 1)
        const right = _nth(this.draggableGroups, newIndex + 1)
        newNumerator = _get(left, 'orderNumerator') + _get(right, 'orderNumerator')
        newDenominator = _get(left, 'orderDenominator') + _get(right, 'orderDenominator')
      }

      console.log('Cardstock: attempting SortableGroup update')

      this.$apollo.mutate({
        mutation: gql`
          mutation ($id: ID!, $numerator: Int!, $denominator: Int!, $tz: String) {
            groupUpdate (id: $id, group: {orderNumerator: $numerator, orderDenominator: $denominator}) {
              id
              name
              insertedAt(tz: $tz)
              updatedAt(tz: $tz)
              studentCount
              order
              orderNumerator
              deletedAt(tz: $tz)
              deletingTeacher {
                id
                first
                last
              }
              icon {
                id
                name
              }
              color {
                id
                name
              }
              orderDenominator
              students {
                id
                first
                last
              }
            }
          }
        `,
        variables: {
          id: movedItemId,
          numerator: newNumerator,
          denominator: newDenominator,
          tz: tz()
        }
      }).then((data) => {
        console.log('Cardstock: SortableGroups successful GroupUpdate')
      }).catch((error) => {
        console.log('Cardstock: SortableGroups nhandleable error on GroupUpdate')
      })
    }
  }
}
</script>
